export default "__VITE_ASSET__DNMUsWRU__"